import styled, { css } from 'styled-components';
import { Icon as IconBase } from '../icon';
import { themeColor } from '../../../theme/getters';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const hiddenStyles = css`
  opacity: 0;
  pointer-events: none;
`;

const Icon = styled(IconBase).attrs(() => ({ size: 24, stroked: true }))`
  cursor: pointer;
  ${({ visible }) => (!visible ? hiddenStyles : '')}
`;

export const MinusIcon = styled(Icon).attrs(() => ({
  name: 'minus',
}))``;

export const PlusIcon = styled(Icon).attrs(() => ({
  name: 'plus',
}))``;

export const Value = styled.span`
  min-width: 50px;
  text-align: center;
  font-size: 20px;
  line-height: 27px;
  color: ${themeColor('primary')};
`;
